import { makeCustomIcon } from './utils';

export const dimEnhancedIcon = makeCustomIcon(
  'Enhanced',
  32,
  32,
  'm0 17.25h7l0 2h4c1 0 3 1 3.75 2v10.75zm32 0h-7l0 2h-4c-1 0-3 1-3.75 2v10.75zm-32-2.5h7l0-2h4c1 0 3-1 3.75-2v-10.75zm32 0h-7l0-2h-4c-1 0-3-1-3.75-2v-10.75z',
);
